<template>
  <div class="create-account-encouragement">
    <div class="main-container">
      <img  class="testimonial-title-image" src="@/assets/static/img/encouragement/quote.svg" />
      <div class="testimonial">{{ testimonial }}</div>
    </div>
    <img class="crisp-green-icon" src="@/assets/static/img/encouragement/crisp-green-logo.png" />
    <div class="quotee-name">{{ quotee_name }}</div>
    <div class="quotee-title">{{ quotee_title }}</div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        testimonial: "Plyo has helped drive the traffic of our targeted demographic to our store, helping create repeat customers who value the redemption rewards we offer. Plyo has no doubt been a key element in connecting with the student population. At CRISP & GREEN, we look forward to building on our current relationship with Plyo as they continue to expand their platform to other universities.",
        quotee_name: 'Alex Humphries',
        quotee_title: 'General Manager, Crisp & Green',
      }
    },
  }
</script>